// Hysteresis thresholds to prevent flickering up to segment length
const HYSTERESIS_LENGTH = 1.6;
const SEEK_THRESHOLD_DISABLE = 0.5;
const SEEK_THRESHOLD_ENABLE = SEEK_THRESHOLD_DISABLE + HYSTERESIS_LENGTH;
export const seekableRangeAllowsSeekForward = (currentPosition, currentCanSeekForward, seekableRange) => {
    if (!seekableRange || currentPosition === null) {
        return false;
    }
    const distanceFromEnd = seekableRange.end - currentPosition;
    if (currentCanSeekForward) {
        return distanceFromEnd > SEEK_THRESHOLD_DISABLE;
    }
    return distanceFromEnd > SEEK_THRESHOLD_ENABLE;
};
export const seekableRangeAllowsSeekBackward = (currentPosition, currentCanSeekBackward, seekableRange) => {
    if (!seekableRange || currentPosition === null) {
        return false;
    }
    const distanceFromStart = currentPosition - seekableRange.start;
    if (currentCanSeekBackward) {
        return distanceFromStart > SEEK_THRESHOLD_DISABLE;
    }
    return distanceFromStart > SEEK_THRESHOLD_ENABLE;
};
export const getPlaybackSeekableRangeState = ({ currentPosition, seekableRange, currentCanSeekForward, currentCanSeekBackward, }) => {
    const canSeekForward = seekableRangeAllowsSeekForward(currentPosition, currentCanSeekForward ?? false, seekableRange);
    const canSeekBackward = seekableRangeAllowsSeekBackward(currentPosition, currentCanSeekBackward ?? false, seekableRange);
    return {
        canSeekForward,
        canSeekBackward,
    };
};
